import Link from 'next/link';
import { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Load follow scripts here
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
    // Delete no esencial cookies
    document.cookie.split(";").forEach(c => {
      if (!c.includes('necessary')) {
        document.cookie = c.replace(/^ +/, "")
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      }
    });
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 bg-blue-400 shadow-lg z-50">
      <div className='flex justify-center items-center space-x-4'>
        <p className="text-sm text-white my-4">
            We use cookies to ensure that we give you the best experience on our website. <br />If you continue to use this site we will assume that you are happy with it. 
          <Link href="/privacy-policy" target="_blank" className="text-white underline ml-3">Privacy Policy</Link>
        </p>
        <div className="flex space-x-2">
          <button
            onClick={handleAccept}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
          >
            OK
          </button>
          <button
            onClick={handleReject}
            className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600 transition-colors"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;